import Spacer from '../Spacer/Spacer.jsx'
import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react'
import {getMainImage, getModelUrl} from '../../../../utils/Model.js'
import '../../styles/styles.scss'
import {getBaseImagePath} from "../../../../ui/catalog/Utils";


import {Navigation, Autoplay} from "swiper/modules";
import {useQuery} from "@tanstack/react-query";
import {getModelColorItems} from "../../../../api/catalog";


const Slider = props => {
	const categoryId = props.params.articules

	const {data: modelColorItemsData} = useQuery({
		queryKey: [categoryId],
		queryFn: () => getModelColorItems({
			articules: [categoryId]
		})
	})

	const {model_color_items: modelColorItems, meta: _} = modelColorItemsData || {model_color_items: [], meta: undefined}

	const [swiper, setSwiper] = React.useState()

	const navigationPrevRef = React.useRef(null);
	const navigationNextRef = React.useRef(null);

	return (
		<>
			<div className='mblock '>
				<div className='carousel-container'>
					<div className='swiper-button' ref={navigationPrevRef}>
						<img
							src='/public/new-design/lookbook2019d3/desktop/arrow_1.png'
							alt=''
						/>
					</div>

					<Swiper
						grabCursor={true}
						centeredSlides={false}
						slidesPerView={1}
						loop={true}
						speed={400}
						spaceBetween={0}
						modules={[Autoplay, Navigation]}
						autoplay={{
							delay: 1000,
						}}
						navigation={{
							prevEl: navigationPrevRef.current,
							nextEl: navigationNextRef.current,
						}}

						breakpoints={{
							640: {
								slidesPerView: 2,
								spaceBetween: 20,
							},
							700: {
								slidesPerView: 2,
								spaceBetween: 30,
							},
							768: {

								slidesPerView: 2,
								spaceBetween: 30,

							},
						}}
						onSwiper={setSwiper}
					>
						{modelColorItems.map((colorItem, i) => {
							const image = getMainImage(colorItem)
							return (
								<SwiperSlide key={i}>
									<img src={getBaseImagePath() + image.url} alt='' />
									<div className='model-label slLabel'>
										<a target='_blank' href={getModelUrl(colorItem)}>
											КУПИТЬ
										</a>
									</div>
								</SwiperSlide>
							)
						})}
					</Swiper>
					<div className='swiper-button' ref={navigationNextRef}>
						<img
							src='/public/new-design/lookbook2019d3/desktop/arrow_2.png'
							alt=''
						/>
					</div>
				</div>
				<div
					className='slider-swipe-pic'
				>
					<img
						src='/public/landing/megalanding_mobile/swipe.png'
						alt='swipePic'
					/>
				</div>
			</div>
			<Spacer />
		</>
	)
}

export default Slider